import { RootState } from '@/store/types';
import { Module, GetterTree, MutationTree, ActionTree } from 'vuex';
import { CyModule, CyModuleTreeNode, CyModuleState } from '@/store/modules/cyModule/types';
import { moduleAPI } from '@/api/cyModule';

export const moduleName = "cyModule";

export enum CyModuleGetters {
    getCyModuleList = "GET_CY_MODULE_LIST",
    getCyModuleTree = "GET_CY_MODULE_TREE",
    getCyModuleMap = "GET_CY_MODULE_MAP",
    getCyModuleListLoading = "GET_CY_MODULE_LIST_LOADING",
}

export enum CyModuleMutations {
    setCyModuleList = "SET_CY_MODULE_LIST",
    setCyModuleTree = "SET_CY_MODULE_TREE",
    setCyModuleListLoading = "SET_CY_MODULE_LIST_LOADING",
}

export enum CyModuleActions {
    asyncGetCyModuleList = "ASYNC_GET_CY_MODULE_LIST",
}

const state: CyModuleState = {
    isLoading: false,
    moduleList: [],
    moduleTree: [],
    moduleMap: {},
}

export const getters: GetterTree<CyModuleState, RootState> = {
    [CyModuleGetters.getCyModuleList](state): CyModule[] {
        return state.moduleList;
    },
    [CyModuleGetters.getCyModuleTree](state): CyModuleTreeNode[] {
        return state.moduleTree;
    },
    [CyModuleGetters.getCyModuleMap](state): Record<number, CyModule> {
        return state.moduleMap;
    },
    [CyModuleGetters.getCyModuleListLoading](state): boolean {
        return state.isLoading;
    },
}

export const mutations: MutationTree<CyModuleState> = {
    [CyModuleMutations.setCyModuleList](state, payload: CyModule[]): void {
        state.moduleList = payload;
    },
    [CyModuleMutations.setCyModuleTree](state, payload: CyModule[]): void {

        const moduleTree: CyModuleTreeNode[] = []
        const moduleTreeMap: Record<number, CyModuleTreeNode> = {}

        payload.forEach(item => {
            if (!moduleTreeMap[item.type]) {
                const node: CyModuleTreeNode = { ...item, children: [] }
                moduleTreeMap[item.type] = node
                state.moduleMap[item.type] = node
            }
        })
        payload.forEach(item => {
            const parent: CyModuleTreeNode = moduleTreeMap[item.parentTypeId]
            if (parent) {
                parent.children?.push(moduleTreeMap[item.type])
            } else {
                moduleTree.push(moduleTreeMap[item.type])
            }
        })

        state.moduleTree = moduleTree;
    },
    [CyModuleMutations.setCyModuleListLoading](state, payload: boolean): void {
        state.isLoading = payload;
    },
}

export const actions: ActionTree<CyModuleState, RootState> = {
    async [CyModuleActions.asyncGetCyModuleList]({ commit }, { userId }: { userId: number }): Promise<void> {
        try {
            commit(CyModuleMutations.setCyModuleListLoading, true);
            const res = await moduleAPI.listOwnModuleByUserId(userId);
            commit(CyModuleMutations.setCyModuleList, res);
            commit(CyModuleMutations.setCyModuleTree, res)
        } catch (err) {
            console.log(err);
        } finally {
            commit(CyModuleMutations.setCyModuleListLoading, false);
        }
    },

}

export const cyModule: Module<CyModuleState, RootState> = {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
}
